module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-cfd58f5841372659597bb303d21bfb75.png";